
namespace Matrix.Visualizer {

    @Serenity.Decorators.registerClass()
    export class GraphThemeDialog extends Serenity.EntityDialog<GraphThemeRow, any> {
        protected getFormKey() { return GraphThemeForm.formKey; }
        protected getIdProperty() { return GraphThemeRow.idProperty; }
        protected getLocalTextPrefix() { return GraphThemeRow.localTextPrefix; }
        protected getNameProperty() { return GraphThemeRow.nameProperty; }
        protected getService() { return GraphThemeService.baseUrl; }

        protected form = new GraphThemeForm(this.idPrefix);

    }
}